cookieExists = function(cookie) {
	const exists = document.cookie.match(
		new RegExp(
			"(?:^|; )".concat(
				cookie.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1"),
				"=([^;]*)"
			)
		)
	);
	return exists;
};

const FloatingContacts = {
	device:
		"ontouchstart" in window ||
		navigator.MaxTouchPoints > 0 ||
		navigator.msMaxTouchPoints > 0,

	init: function(container, button, liveChatButtons) {
		const _this = this;
		this._this = _this;
		this.button = button;
		this.container = container;
		this.liveChatButtons = liveChatButtons;
		this.contactListItems = container.querySelectorAll(
			".FloatingContacts__list-item"
		);
		this.container.setAttribute(
			"data-device",
			this.device ? "mobile" : "desktop"
		);

		if (this.device) {
			document.addEventListener("touchstart", function(container) {
				if (container) {
					if (
						container.target.classList.contains(
							"FloatingContacts__list"
						) ||
						container.target.classList.contains(
							"FloatingContacts__list-item"
						) ||
						(container.target.closest(
							".FloatingContacts__button"
						) &&
							!container.classList.contains("show"))
					) {
						return void _this.openDialog();
					}
					_this.closeDialog();
				}
			});
		} else {
			document
				.querySelector(".FloatingContacts__button")
				.addEventListener("mouseenter", function() {
					_this.openDialog();
				});
		}

		document
			.querySelector(".FloatingContacts")
			.addEventListener("mouseleave", function(button) {
				(button.target.classList.contains("FloatingContacts__list") &&
					button.target.closest(".FloatingContacts__button")) ||
					!container.classList.contains("show") ||
					_this.closeDialog();
			});

		Array.prototype.slice
			.call(this.contactListItems)
			.forEach(function(conatactItem) {
				return conatactItem.addEventListener("click", function(
					conatactItem
				) {
					return _this.closeDialog();
				});
			});

		this.load();
	},

	load: function() {
		this.container.classList.remove("position-top"),
			(this.container.style.bottom = "17px"),
			this.container.classList.add("chat-loaded"),
			this.container.classList.add("FloatingContacts_loaded");
	},
	closeDialog: function() {
		this.container.classList.remove("show"),
			this.button.classList.remove(
				"FloatingContacts__button_dialog-open"
			);
	},

	openDialog: function() {
		this.container.classList.add("show"),
			this.button.classList.add("FloatingContacts__button_dialog-open");
	}
};

document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelector(".FloatingContacts")) {
		FloatingContacts.init(
			document.querySelector(".FloatingContacts"),
			document.querySelector(".FloatingContacts__button"),
			document.querySelectorAll("[data-show-livechat]")
		);
	}
});
